export class CreatePasswordRequestModel {
    public key: string;
    public secret: string;
    public password: string;
    public confirmPassword: string;
}
